export default __webpack_public_path__ + "static/media/smps15b5.370228d5.webp";